<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-name">
                <h2 id="benefitHeader">
                    {{pageTitle}}
                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
                </h2>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="card-body">
                    <form id="changeProfile" class="CustomChangeProfile">

                        <!--Stations-->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="station">Enter Station<span class="text-danger">*</span></label>
                                <input id="station" v-model="station" type="text" class="form-control" placeholder="Enter Station">
                                <font class="text-danger">{{stationError}}</font>
                            </div>
                        </div>

                        <div class="clearfix"></div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <!--<button @click="bind()">Bind</button>-->
                        </div>
                        <br/>
                        <!--Error Alert-->
                        <div class="row clearfix" >
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="alert alert-danger" id="alertError">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <!--Buttons-->
                        <div class="row clearfix"></div>
                        <div class="button-demo">
                            <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateStationLocation ()">
                            <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdateStationLocation (flag='Save and Continue')">
                            <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateStationLocation ()"></input>-->
                            <input id="CancelBenifit" type="submit" value="Cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                        </div>

                        <!--page content-->
                        <app-footer></app-footer>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import {HTTP} from '../http-common';
    import FrontFooter from '@/components/FrontFooter';
    import {commonMixins} from '../mixins/commonMixins';
    export default {
        name: 'AddStation',
        props: [''],
        mixins: [commonMixins],
        components: {
            'app-footer':FrontFooter,
        },
        data() {
            return {
                station:'',
                // Frontend Error
                stationError : '',

//                BackEnd Error
                backendErrors: [],
                pageTitle : 'Add Stations'
            }
        },
        mounted: function () {
            self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'updatestation') {
                if (segments[2]) {
                    self.loadStationData();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Station";
                }
            }
            $("#alertError").hide();
        },
        watch: {

        },
        methods: {
            onChnageStation : function () {
                self.stationError = '';
            },
            onchangeLocation : function () {
                self.locationError = '';
            },
            buttonBack : function () {
                self.$router.push('/liststations');
            },

            loadStationData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[2],
                };

                HTTP.post("/station/getstation/" + segments[2], data, config)
                    .then(function (response) {
                        self.station = response.data.content[0].name;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },

            checkForm: function () {
                var checked = true;
                if (!self.station) {
                    self.stationError = "Station Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            addUpdateStationLocation (flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    if (segments[1] == 'updatestation') {
                        if (segments[2]) {
                            var data = {
                                station_name: self.station,
                                id: segments[2],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            station_name: self.station,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }

                    HTTP.post("/station/addupdate", data, config)
                        .then(function (response) {
                            if (segments[1] == 'updatestation') {
                                if (segments[2]) {
                                    $("#addBenifitBtn").val("Update");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueBenifitBtn").val("Save and Continue");
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                } else {
                                    $("#addBenifitBtn").val("Save");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                }
                            }

                            if (response.data.status == "success") {
                                $("#errorMsg").html(response.data.content);
                                if (flag == "Save and Continue") {
                                    self.station = '';
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                } else {
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                        self.buttonBack();
                                    }, 5000);
                                }
                            } else {
                                $("#alertError").show();
                                if (response.data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < response.data.content.length; i++) {
                                        err += response.data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                }
                                setTimeout(function () {
                                    $(".alert-danger").hide();
                                }, 5000);
                            }
                        })
                        .catch(function (err) {
                            if (segments[1] == 'updatestation') {
                                if (segments[2]) {
                                    $("#addBenifitBtn").val("Update");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        self.station = '';
                                        $(".alert-danger").show();
                                        setTimeout(function () {
                                            $(".alert-danger").hide();
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").show();
                                        setTimeout(function () {
                                            $(".alert-danger").hide();
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").show();
                                        setTimeout(function () {
                                            $(".alert-danger").hide();
                                        }, 5000);
                                    }
                                }
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").val("Save and Continue");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                    $("#errorMsg").html(err.response.data.message);
                                    self.station = '';
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                } else {
                                    $("#addBenifitBtn").val("Save");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").prop("disabled", true);
                                    $("#CancelBenifit").prop("disabled", false);
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                }

                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").show();
                                    setTimeout(function () {
                                        $(".alert-danger").hide();
                                    }, 5000);
                                }
                            }
                        });
                }
            },

        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/AddStation.vue